<template>
<div>
    <div class="row order_details_content">
        <div class="col_12">
            <div class="card mt_20">
                <div class="card-header">
                    <div class="card-title">{{ $t('sidebar.orderManagement.subscriptionInformation') }}</div>
                </div>
                <div class="card-body ">
                    <div class="table_half">
                        <div class="inner">
                            <div class="table_responsive">
                                <table class="table">
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.parents') }}</th>
                                        <td>{{ orderData.parent ? orderData.parent.name : '' }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.parent_email') }}</th>
                                        <td>{{ orderData.parent ? orderData.parent.email : '' }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.startDate') }}</th>
                                        <td>{{ orderData.ordered_at }}</td>
                                    </tr>

                                </table>
                            </div>
                        </div>
                        <div class="inner">
                            <div class="table_responsive">
                                <table class="table">
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.Student') }}</th>
                                        <td>{{ orderData.student ? orderData.student.name : '' }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.assistentPhone') }}</th>
                                        <td>{{ orderData.buyer_phone }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.endDate') }}</th>
                                        <td>{{ orderData.expired_at }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col_12">
            <div class="card">
                <div class="card-header">
                    <div class="card-title">{{ $t('sidebar.orderManagement.orderInformation') }}</div>
                </div>
                <div class="card-body ">
                    <div class="table_half">
                        <div class="inner">
                            <div class="table_responsive">
                                <table class="table">
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.dateOfPurchase') }}</th>
                                        <td>{{ orderData.ordered_at }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.orderNumber') }}</th>
                                        <td>{{ orderData.order_number }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.purchaseProductName') }}</th>
                                        <td>{{ orderData.package ? orderData.package.package_name : '' }}</td>
                                    </tr>
                                    <tr v-if="orderData.order_status == 'refunded' || orderData.order_status == 'partially-refunded'">
                                        <th>환불 날짜</th>
                                        <td>{{ orderData.refunded_at }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="inner">
                            <div class="table_responsive">
                                <table class="table">
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.subscriptionNumber') }}</th>
                                        <td>{{ orderData.package_code }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.paymentMethod') }}</th>
                                        <td>{{ orderData.payment_type }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.orderAmount') }}</th>
                                        <td>{{ orderData.amount_formated }} 원</td>
                                    </tr>
                                    <tr v-if="orderData.order_status == 'refunded' || orderData.order_status == 'partially-refunded'">
                                        <th>환불금액</th>
                                        <td>{{ orderData.refund_amount_formated }} 원</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col_12">
            <div class="card">
                <div class="card-header">
                    <div class="card-title">{{ $t('sidebar.orderManagement.paymentInformation') }}</div>
                </div>
                <div class="card-body">
                    <div class="table_half">
                        <div class="inner">
                            <div class="table_responsive">
                                <table class="table">
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.productName') }}</th>
                                        <td>{{ orderData.package ? orderData.package.package_name : '' }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.coupon') }}</th>
                                        <td>{{ orderData.coupon }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.couponAmount') }}</th>
                                        <td>{{ orderData.coupon_amount_formated }} 원</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.orderStatus') }}</th>
                                        <td class="">
                                            <div class="inner_tre">
                                                <select class="form_global width_200p" v-model="orderForm.order_status">
                                                    <option value="pending">{{ $t('sidebar.orderManagement.pending') }}</option>
                                                    <option value="accepted">{{ $t('sidebar.orderManagement.accepted') }}</option>
                                                    <option value="rejected">{{ $t('sidebar.orderManagement.rejected') }}</option>
                                                    <option value="refunded">{{ $t('sidebar.orderManagement.refunded') }}</option>
                                                    <option value="partially-refunded">{{ $t('sidebar.orderManagement.partiallyRefunded') }}</option>
                                                </select>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="inner">
                            <div class="table_responsive">
                                <table class="table">
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.productAmount') }}</th>
                                        <td>{{ orderData.per_unit_price }} 원</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.discountAmount') }}</th>
                                        <td>{{ orderData.discount_formated ? orderData.discount_formated : 0 }} 원</td>
                                    </tr>
                                    <tr>
                                        <th>Delivery Fee</th>
                                        <td>{{ orderData.delivery_fee_formated }} 원</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('sidebar.orderManagement.actualPaymentAmount') }}</th>
                                        <td>{{ orderData.amount_formated }} 원</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="table_full">
                        <div class="table_responsive">
                            <table class="table">
                                <tr v-if="orderData.order_status == 'refunded' || orderData.order_status == 'partially-refunded'">
                                    <th>환불 사유</th>
                                    <td class="">
                                        {{ orderData.refund_reason }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ $t('sidebar.orderManagement.shippingAddress') }}</th>
                                    <td class="">
                                        {{ orderData.address }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ $t('common.memo') }}</th>
                                    <td class="">
                                        <textarea rows="4" cols="70" class="form_global" spellcheck="false" v-model="orderForm.note"></textarea>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col_12">
            <div class="d_flex_end form_action_btn">
                <router-link class="btn btn_danger ml_10" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
                <button class="btn btn_blue ml_10" @click.prevent="submitForm()">{{ $t('common.save') }}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            title: this.$t('sidebar.orderManagement.orderDetails'),
            cancelRouteName: 'orders',
            orderData: [],
            orderForm: {
                order_status: '',
                note: '',
            }
        }
    },
    created() {
        if (this.$route.name === 'order_edit') {
            this.axios.get('/orders/' + this.$route.params.id)
                .then((response) => {
                    this.orderData = response.data.data
                    this.orderForm.order_status = response.data.data.order_status
                    this.orderForm.note = response.data.data.note
                })
        }
    },
    methods: {
        submitForm() {
            this.axios.patch('/orders/' + this.$route.params.id, this.orderForm)
                .then(() => {
                    this.$router.push({
                        name: 'orders'
                    });
                    this.showSuccessMsg(this.$t('common.updateSuccess'))
                })
                .catch((err) => {
                    this.allErrors = err.response.data.errors;
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>
